
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Form } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { motion } from "framer-motion";
import { LoanDetailsSectionSv } from "./LoanDetailsSectionSv";
import { PersonalInfoSectionSv } from "./PersonalInfoSectionSv";
import { LoanInfoNoticesSv } from "./LoanInfoNoticesSv";
import { FormValues } from "@/types/loan";
import { useIsMobile } from "@/hooks/use-mobile";
import { Button } from "@/components/ui/button";
import { LoaderCircle } from "lucide-react";

interface LoanApplicationFormProps {
  form: UseFormReturn<FormValues>;
  handleSubmit: (data: FormValues) => Promise<void>;
  loanAmount: number;
  setLoanAmount: (value: number) => void;
  loanTerm: number;
  setLoanTerm: (value: number) => void;
  interest: number;
  isSubmitting: boolean;
  monthlyPayment: number;
  totalPaid: number;
  interestAndFees: number;
  monthlyFee?: number;
  setupFee?: number;
  setTermsOpen?: (value: boolean) => void;
  setPrivacyPolicyOpen?: (value: boolean) => void;
  setLoanType?: (value: string) => void;
}

export const LoanApplicationFormSv = ({
  form,
  handleSubmit,
  loanAmount,
  setLoanAmount,
  loanTerm,
  setLoanTerm,
  interest,
  isSubmitting,
  monthlyPayment = 0,
  totalPaid = 0,
  interestAndFees = 0,
  monthlyFee = 5,
  setupFee = 150,
  setTermsOpen = () => {},
  setPrivacyPolicyOpen = () => {},
  setLoanType = () => {}
}: LoanApplicationFormProps) => {
  const isMobile = useIsMobile();
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="mb-10 w-full"
    >
      <Card className="bg-white mb-8 overflow-hidden w-full max-w-full shadow-md">
        <CardHeader className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-4 md:p-6">
          <CardTitle className="text-xl md:text-2xl">Jämför ditt lån nu</CardTitle>
          <CardDescription className="text-blue-100 text-sm md:text-base">Fyll i ansökan och få erbjudanden snabbt</CardDescription>
        </CardHeader>
        <CardContent className="p-2 md:p-6">
          <Form {...form}>
            <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-6 w-full">
              <div className="space-y-6 w-full">
                <LoanDetailsSectionSv 
                  form={form}
                  loanAmount={loanAmount}
                  setLoanAmount={setLoanAmount}
                  loanTerm={loanTerm}
                  setLoanTerm={setLoanTerm}
                  monthlyPayment={monthlyPayment}
                  totalPaid={totalPaid}
                  interestAndFees={interestAndFees}
                  interest={interest}
                  setLoanType={setLoanType}
                />
                
                <PersonalInfoSectionSv 
                  form={form} 
                  setTermsOpen={setTermsOpen}
                  setPrivacyPolicyOpen={setPrivacyPolicyOpen}
                />
              </div>
              
              <LoanInfoNoticesSv isSubmitting={isSubmitting} />
            </form>
          </Form>
        </CardContent>
      </Card>
    </motion.div>
  );
};
